/* oxlint-disable react/jsx-no-target-blank */
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as style from './NavigationLink.css';

export interface INavigationLinkProps {
  label: string;
  anchor: string;
  count?: number;
  isAcitve?: boolean;
  onClick?(event: React.MouseEvent<HTMLElement>): void;
}

export const NavigationLink = (props: INavigationLinkProps) => {
  const { label, anchor, count, isAcitve, onClick } = props;
  const hasCount = Boolean(count && count > 0);

  return (
    <a
      role="button"
      onClick={onClick}
      {...mergeStyles(style['navigation-link'], isAcitve && style['active-link'])}
      href={`#${anchor}`}
    >
      <span className={style['content']}>
        <span>{label}</span>
        {hasCount && <span className={style['count']}>{count}</span>}
      </span>
    </a>
  );
};
